/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faTh} from '@fortawesome/pro-duotone-svg-icons';

const SectionsIcon = ({icon, ...props}) => (
  <FontAwesomeIcon icon={faTh} {...props} />
);

export default SectionsIcon;
